export enum ServiceWorkerContext {
    BACKGROUND = 'background',
    PREVIEW = 'preview',
}
